import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    {label: 'All year', value: 'all'},
    {label: 'Custom Date', value: 'custom'}
]

export default function SelectRange({...props}) {

    const myProps = {
        options: OPTIONS,
        isClearable: false, firstSelect: false, isMulti: false,
        icon: {icon: 'calendar'},
        ...props
    }

    return <SelectSeeker {...myProps} />
}